import { CoreMenuItem } from "./core-menu";

export const SYSTEM_NAVIGATION_MENU: CoreMenuItem[] = [
  //Component menu
  // {
  //   id: "",
  //   title: "MENU.COMPONENT",
  //   url: "/default-component",
  //   icon: "note",
  //   type: "item",
  // },
  //Dashboard menu
  {
    id: "",
    title: "MENU.DASHBOARD",
    url: "/dashboard",
    icon: "element-11",
    type: "item",
  },
  {
    id: "",
    title: "MENU.ENTRY_INFO",
    url: "/entry-information",
    icon: "profile-user",
    type: "item",
  },

  {
    id: "",
    title: "MENU.LEAVE_LATE_INFO",
    url: "/leave-late-information",
    icon: "document",
    type: "item",
  },
  {
    id: "",
    title: "MENU.EMPLOYEE",
    url: "/employee",
    icon: "user",
    type: "item",
  },
  {
    id: "",
    title: "MENU.SALARY",
    url: "/app",
    icon: "",
    type: "section",
    children: [
      {
        id: "",
        title: "MENU.SALARY",
        url: "",
        icon: "two-credit-cart",
        type: "accordion",
        children: [
          {
            id: "",
            title: "MENU.SALARY",
            url: "/salary",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.ALLOWANCE",
            url: "/allowances",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.COMMISSION",
            url: "/commissions",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.PAYROLL_SLIPS",
            url: "/payroll-slips",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.COLLECT_POINTS",
            url: "/collect-points",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.OTHER",
            url: "/others",
            icon: "",
            type: "item",
            children: [],
          },
        ],
      }
    ],
  },
  //Layout Builder menu
  // {
  //   id: "",
  //   title: "Layout Builder",
  //   url: "/builder",
  //   icon: "switch",
  //   type: "item",
  // },
  //Crafted section
  {
    id: "",
    title: "MENU.SETTING",
    url: "/app",
    icon: "",
    type: "section",
    children: [
      {
        id: "",
        title: "MENU.SETTING",
        url: "/apps/settings",
        icon: "setting-2",
        type: "accordion",
        children: [
          {
            id: "",
            title: "MENU.USER",
            url: "/user",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.PERMISSION",
            url: "/permission",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.HOLIDAY",
            url: "/holiday",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.LEAVE",
            url: "/leave",
            icon: "",
            type: "item",
            children: [],
          }, {
            id: "",
            title: "MENU.SPECIAL_LEAVES",
            url: "/special-leaves",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.FINE",
            url: "/fine",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.COMPANY_INFORMATION",
            url: "/company-information",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.DEPARTMENT_INFORMATION",
            url: "/department-information",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.JOB_POSITION",
            url: "/job-position",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.POLICY_MANAGEMENT",
            url: "/policy-management",
            icon: "",
            type: "item",
            children: [],
          },
          {
            id: "",
            title: "MENU.CALENDAR_YEAR",
            url: "/working-year",
            icon: "",
            type: "item",
          },
          {
            id: "",
            title: "MENU.REPORT_ATTENDANCE_LEAVINGS",
            url: "/report-attendance-leavings",
            icon: "",
            type: "item",
          },
          {
            id: "",
            title: "MENU.AUDIT_LOG",
            url: "/audit-logs",
            icon: "",
            type: "item",
          },
          {
            id: "",
            title: "MENU.CHANGE_PASSWORD",
            url: "/change-password",
            icon: "",
            type: "item",
          },
        ],
      }
    ],
  },
];
